import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { isPolicyEditable } from '../../../util/util';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import AddPerilModal from './AddPerilModal';
import PerilsList from './PerilsList';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const Perils = (props: Props) => {
	const { t } = useTranslation();
	const { policyData, authData } = props;

	const { selectedExposure, productConfig, selectedQuote, policy } = policyData;

	const isInEditMode =
		authData.hasPermission('quote.update') &&
		isPolicyEditable(policy, selectedQuote);

	const policyConfig = productConfig.policyConfiguration;
	const exposureConfig = policyConfig.exposures.find(
		(e) => e.name === selectedExposure.name,
	);
	const perilConfigs = exposureConfig.perils;

	const renderActions = () => {
		return (
			<AddPerilModal
				perilConfigs={perilConfigs}
				exposureLocator={selectedExposure.locator}
				policyData={policyData}
				authData={authData}
			/>
		);
	};

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>{t('peril.plural.upper')}</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<PerilsList perils={selectedExposure.perils} />
			</StyledSectionContainer>
			{isInEditMode && renderActions()}
		</>
	);
};

export default withPolicyContext<Props>(Perils);
